/*
import QueryResult from '@/common/network/QueryResult';
import ToFormDataSerializationStrategy from '@/common/network/serialization/ToFormDataSerializationStrategy';
import { UploadImageResponse } from '@/common/types/uploadFile';

import CutwiseAPIClient, { METHOD_POST } from '../network/CutwiseAPIClient';

export const PATH_UPLOAD_IMAGE = 'api/upload/image';

export default class S3UploadAPI {
  uploadImage(file: File): Promise<QueryResult<UploadImageResponse>> {
    const qb = CutwiseAPIClient.createQueryBuilder()
      .method(METHOD_POST)
      .path(PATH_UPLOAD_IMAGE)
      .body({ auto: file })
      .serializer(ToFormDataSerializationStrategy)
      .suppressErrorNotifications();

    const query = qb.getQuery();

    return CutwiseAPIClient.sendQuery(query);
  }
}
*/

import { FetchService } from '@/dmdrive/core/service/FetchService';
import { UploadImageResponse } from '@/dmdrive/core/types/UploadImage';

export const PATH_UPLOAD_IMAGE = '/api/upload/image';

export class S3UploadAPI {
  uploadImage(file: File) {
    const body = new FormData();

    body.append('auto', file);

    return FetchService.post<UploadImageResponse>(PATH_UPLOAD_IMAGE, { body, headers: { 'Content-Type': null } });
  }
}
